exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer[data-v-041e3202] {\n  position: fixed;\n  bottom: 0;\n  width: 100%;\n  margin-bottom: 16px;\n}\n.footer a[data-v-041e3202] {\n  height: 24px;\n  width: 123px;\n  color: rgba(0,0,0,0.25);\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 24px;\n  text-align: center;\n  padding: 0 8px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/stylus-loader!./node_modules/vue-loader/lib??vue-loader-options!./src/components/common/Footer.vue?vue&type=style&index=0&id=041e3202&lang=stylus&scoped=true
// module id = 288
// module chunks = 4